import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  top: 90px;
  right: 24px;
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 200px;
  z-index: 1000;
  border: 1px solid #e0e0e0;

  @media (max-width: 960px) {
    top: 80px;
    bottom: auto;
    right: 24px;
    width: 160px;
    padding: 12px;
    gap: 8px;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #212121;
  text-align: center;

  @media (max-width: 960px) {
    font-size: 13px;
  }
`;

export const DonationText = styled.p`
  margin: 0;
  font-size: 11px;
  color: #616161;
  text-align: center;
  line-height: 1.4;

  @media (max-width: 960px) {
    font-size: 10px;
  }
`;

export const QRCodeWrapper = styled.div`
  background: white;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  justify-content: center;

  @media (max-width: 960px) {
    display: none;
  }
`;

export const CopyButton = styled.button`
  background: #ed4e2a;
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s;

  &:hover {
    background: #d8431f;
  }
`;

export const PixKey = styled.p`
  margin: 0;
  font-size: 10px;
  color: #757575;
  text-align: center;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
